/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_SplitInputs */

const vi_lot_items_split = /** @type {(inputs: Lot_Items_SplitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tách lô`)
};

/**

* @param {Lot_Items_SplitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split = /** @type {((inputs?: Lot_Items_SplitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_SplitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split(inputs)
});